export default "__VITE_ASSET__19b12bc0__"